// ========================================
// INTERFACES DE CHECKPOINT
// ========================================

/**
 * Categoria do checkpoint
 */
export enum CheckpointCategory {
    SECURITY = 'SECURITY',
    MAINTENANCE = 'MAINTENANCE',
    INSPECTION = 'INSPECTION',
    GENERAL = 'GENERAL',
}

/**
 * Interface base para entidade de checkpoint
 */
export interface ICheckpointResponse {
    readonly id: string;
    readonly name: string;
    readonly description?: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly required: boolean;
    readonly category: CheckpointCategory;
    readonly order?: number;
    readonly estimatedDuration?: number;
    readonly isActive: boolean;
    readonly companyId: string;
    readonly postId: string;
    readonly createdAt?: Date;
    readonly updatedAt?: Date;
    readonly deletedAt?: Date;

    // Relacionamentos
    readonly post?: {
        id: string;
        name: string;
    };
    readonly company?: {
        id: string;
        name: string;
    };
}

/**
 * DTO para criação de checkpoint
 */
export interface ICreateCheckpointDto {
    readonly name: string;
    readonly description?: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly required?: boolean;
    readonly category: CheckpointCategory;
    readonly order?: number;
    readonly estimatedDuration?: number;
    readonly isActive?: boolean;
    readonly postId: string;
    readonly companyId?: string;
}

/**
 * DTO para atualização de checkpoint
 * Nota: Renomeado para evitar conflito com IUpdateCheckpointDto de patrol.interface.ts
 */
export interface IUpdateCheckpointDto {
    readonly name?: string;
    readonly description?: string;
    readonly latitude?: number;
    readonly longitude?: number;
    readonly required?: boolean;
    readonly category?: CheckpointCategory;
    readonly order?: number;
    readonly estimatedDuration?: number;
    readonly isActive?: boolean;
    readonly postId?: string;
}

/**
 * Filtros para busca de checkpoints
 */
export interface ICheckpointFilters {
    readonly page?: number;
    readonly limit?: number;
    readonly search?: string;
    readonly postId?: string;
    readonly companyId?: string;
    readonly category?: CheckpointCategory;
    readonly required?: boolean;
    readonly isActive?: boolean;
}

/**
 * Interface para resposta de paginação de checkpoints
 */
export interface ICheckpointPaginationResponse {
    readonly data: ICheckpointResponse[];
    readonly pagination: {
        readonly page: number;
        readonly limit: number;
        readonly total: number;
        readonly totalPages: number;
        readonly hasNextPage: boolean;
        readonly hasPreviousPage: boolean;
    };
}
